// ABOUTME: Shows a user's name for a user id (catalog list "Updated by", audit log "Performed by").
import {TextRegular} from '@hm/fundamental'
import React from 'react'

import {useUser} from '../../../../common/hooks/useUser'

// Seed/system writers (e.g. "hcp-111556-seed") aren't user ids: skip the lookup and show the raw value.
const USER_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const UserNameCell: React.FC<{userId: string}> = ({userId}) => {
  const {data: user} = useUser(USER_ID_PATTERN.test(userId) ? userId : undefined)
  return <TextRegular>{user?.name || userId}</TextRegular>
}
